import Payment from "../Payment/Payment";

/**
 * @typedef {"school" | "organization"} tenanttype
 */

/**
 * PaymentsPage - Settings page content for Payments/Invoices
 * Renders inside SettingsLayout via Outlet
 * @param {{ type?: tenanttype }} props
 */
const PaymentsPage = ({ type = "school" }) => {
  return <Payment type={type} />;
};

export default PaymentsPage;
